import logger from 'redux-logger'

import {
  asyncMiddlewareCreator,
  AsyncMiddlewareProps,
  errorMiddleware,
  mfaMiddleware,
  persistenceMiddlewareCreator,
  tokenMiddleware,
} from '@percept/redux' 

import { routerMiddleware } from 'connected-react-router'

import analyticsMiddleware from './analytics'

import { sentryMiddlewareCreator } from './sentry'

import { persistence } from '@percept/app-components'

import ignoreMiddleware from './ignore'

import { TRACK } from 'redux/actions'

import { Middleware } from 'redux'

import { History } from 'history'
import thunkMiddleware from 'redux-thunk'
import { StoreState } from 'types'
import { pick } from 'lodash-es'


const {
  WORKLOAD_TYPE,
  NODE_ENV,
  SENTRY_DSN,
  GA_TRACKING_ID,
  GTAG_ID,
} = process.env


const isDevMode = NODE_ENV === 'development',
      isTesting = WORKLOAD_TYPE !== 'PROD' || NODE_ENV === 'development'


const middlewareDebug = {
  analytics: false,
  sentry: false,
}


const ignore = {
  dev: middlewareDebug.analytics ? [] : [TRACK]
}


export type CreateMiddlewareProps = (
  AsyncMiddlewareProps & {
    history: History
  }
)


export const createMiddleware = ({
  history,
  api,
}: CreateMiddlewareProps): Middleware[] => [
  
  thunkMiddleware,

  ...(
    isDevMode && [
      ignoreMiddleware({ env: WORKLOAD_TYPE, ignore }),
      errorMiddleware,
    ] || []
  ) as Middleware[],

  ...(
    !!( ( !isDevMode || middlewareDebug.sentry ) && SENTRY_DSN ) && [
      sentryMiddlewareCreator({ dsn: SENTRY_DSN, env: WORKLOAD_TYPE }),
    ] || []
  ),

  tokenMiddleware,

  mfaMiddleware,

  routerMiddleware(history),
  
  asyncMiddlewareCreator({ api }),

  persistenceMiddlewareCreator<StoreState>({
    persistence,
    serialize: (state) => ({
      ...pick(
        state,
        ['settings', 'filters', 'theming', 'mediaInvestmentCurrencyType'] as (keyof StoreState)[],
      ),
      appState: pick(
        state.appState,
        [
          'referenceDateBehaviour',
          'performanceComparisonRange',
          'insightsReportViewType',
          'targetCurrency',
          'savedQueryStrings',
          'drawerOpen',
        ] as (keyof StoreState['appState'])[]
      ),
    }),
    dbNamePrefix: 'percept-dashboard-',
    dropOnLogout: true,
  }),

  ...(
    !!( GA_TRACKING_ID || GTAG_ID || middlewareDebug.analytics ) && [
      analyticsMiddleware({ GTAG_ID, GA_TRACKING_ID, debug: middlewareDebug.analytics }),
    ] || []
  ),

  ...(
    isTesting && [
      logger
    ] || []
  )

]
